import { render, staticRenderFns } from "./IndicatorEdit.vue?vue&type=template&id=25bbf96f"
import script from "./IndicatorEdit.vue?vue&type=script&lang=js"
export * from "./IndicatorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports